import { render, staticRenderFns } from "./GeneratePostFromUrl.vue?vue&type=template&id=520c055b"
import script from "./GeneratePostFromUrl.vue?vue&type=script&lang=js"
export * from "./GeneratePostFromUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports